import React, { useEffect, useState } from 'react';
import { db } from '../../firebase'
import { collection, query, onSnapshot, doc, setDoc, addDoc, getDoc, getDocs, deleteDoc, updateDoc, where } from 'firebase/firestore';
import { useAuth } from '../../contexts/AuthContext';
import { useContext } from 'react';
import { Button } from '@mui/material';
import { DataGrid, GridToolbar, GridToolbarFilterButton, GridToolbarQuickFilter } from '@mui/x-data-grid'
import { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, Snackbar, Alert, Stack, Modal } from '@mui/material';
import Sidebar from '../Sidebar';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';



function Client() {
    const [error, setError] = React.useState(null);
    const [opn, setOpn] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [addedIt, setAddedIt] = useState(false);
    const [deleted, setDeleted] = React.useState(false);
    const [updated, setUpdated] = React.useState(false);
    const [fetched, setFetched] = React.useState();
    const [open, setOpen] = React.useState(false);
    const [row, setRow] = React.useState([]);

    const [openSelDelete, setOpenSelDelete] = React.useState(false);

    const handleOpn = () => setOpn(true);
    const handleClse = () => setOpn(false);

    // END SELECTION HANDLING

    const [showEdit, setShowEdit] = React.useState(false);
    // ADD CONTACT VARIABLES

    const [openDelete, setOpenDelete] = React.useState(false);


    const handleClose = () => {
        setOpenDelete(false);
        setOpenSelDelete(false);
    }

    function Addnew() {


        const [count, setCount] = React.useState(0);
        const [name, setName] = React.useState('');
        const [clientId, setClientId] = React.useState('');
        const [contact, setContact] = React.useState('');
        const [address, setAddress] = React.useState('');
        const retrive = async () => {
            const q = query(collection(db, "client"));
            const c = await getDocs(q);
            setCount(c.docs.length + 1);

        }
        useEffect(() => {
            retrive();
        }, [])


        const handleName = (event) => {
            setName(event.target.value);
            setAddedIt(false);
        }

        const handleClientId = (event) => {
            setClientId(event.target.value);
        }

        const handleContact = (event) => {
            setContact(event.target.value);
        }
        const handleAddress = (event) => {
            setAddress(event.target.value);
        }
        const disabled = name === '' || contact === '';

        const validatePhone = (phone) => {
            var re = /^\d{10}$/;
            return re.test(phone);
        }

        const handleUpload = async (e) => {
            e.preventDefault();
            setError('');

            const phoneOkay = validatePhone(contact);


            // check if the number is already in the database



            if (phoneOkay === false) {
                setError('Please enter a valid phone number.');
            } else {
                setError('');
                await addDoc(collection(db, "client"), {
                    name: name.charAt(0).toUpperCase() + name.slice(1),
                    contact: contact,
                    clientId: clientId,
                    address: address,
                    count: count,
                    dateadded: new Date().toLocaleString(),

                });

                setAddedIt(true);
                setName('');
                setClientId('');
                setContact('');
                setAddress('');
                setTimeout(() => {
                    setAddedIt(false);
                }, 3000);
                setOpen(false);
                setName('');
                setContact('');
            }
        }
        const handleClose = () => {
            setOpen(false);
            setName('');
            setContact('');
        };






        return (

            <>
                <form onSubmit={handleUpload} className='flex flex-col items-center justify-center gap-2 p-5 mt-5 mb-5 border rounded dark:border-white-rgba-1'>

                    <label className='text-sm font-bold dark:text-white-rgba-7'>Name</label>
                    <input maxLength={50} className='w-2/4 p-2 border rounded lg:w-1/4 border-linkblue dark:border-white-rgba-2 dark:bg-grayer dark:text-white-rgba-6 cont' type='text' value={name} onChange={handleName} placeholder="Eg. Hari" />

                    <label className='text-sm font-bold dark:text-white-rgba-7'>Bill Number</label>
                    <input className='w-2/4 p-2 border rounded lg:w-1/4 border-linkblue dark:border-white-rgba-2 dark:bg-grayer dark:text-white-rgba-6 cont' type='text' value={clientId} onChange={handleClientId} placeholder="Bill No." />

                    <label className='text-sm font-bold dark:text-white-rgba-7'>Contact</label>
                    <input maxLength={10} className='w-2/4 p-2 border rounded lg:w-1/4 border-linkblue dark:border-white-rgba-2 dark:bg-grayer dark:text-white-rgba-6 cont' type='text' value={contact} onChange={handleContact} placeholder="Eg. 9696969696" />

                    <label className='text-sm font-bold dark:text-white-rgba-7'>Address</label>
                    <input className='w-2/4 p-2 border rounded dark:text-white-rgba-6 lg:w-1/4 border-linkblue dark:border-white-rgba-2 dark:bg-grayer cont' type='text' value={address} onChange={handleAddress} placeholder="Eg. damak,jhapa" />

                    {error && <p className='text-sm text-red-500'>{error}</p>}
                    {addedIt && <Alert variant='outlined' className='my-3 text-sm text-green-500'>Client added successfully</Alert>}

                    <div className='flex gap-2'>
                        <Button
                            disabled={disabled}
                            className={`${disabled === true && 'bg-opacity-40 dark:bg-white-rgba-1 dark:text-white-rgba-2'} p-2 border rounded bg-linkblue hover:bg-linkbluer text-white uppercase w-1/8 dark:bg-white-rgba-3 dark:hover:bg-white-rgba-2`}
                            type='submit'
                        >
                            Add
                        </Button>

                        <Button className='p-2 text-white uppercase border rounded bg-linkred hover:bg-linkredder w-1/8' onClick={handleClose}>Cancel</Button>
                    </div>
                </form>
            </>
        )
    }
    const getData = async () => {
        setLoading(true);
        setFetched(false);
        const q = query(collection(db, "client"));
        // const querySnapshot = await getDocs(q);

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            var data = [];
            var elements = {};

            querySnapshot.forEach((doc) => {
                elements = {
                    id: doc.id,
                    name: doc.data().name,
                    clientId: doc.data().clientId,
                    contact: doc.data().contact,
                    address: doc.data().address,

                }
                data.push(elements);
                setRow(data);
            });
        })
        setLoading(false);
        setFetched(true);
    }
    const editContact = async (e) => {
        const field = e.field;
        const value = e.value;
        try {
            await setDoc(doc(db, "client", e.id), {
                [field]: value,

            },
                { merge: true }
            );
            setUpdated(true);

        } catch (error) {
            console.log(error);
        }
    }
    const updateData = async () => {
        setLoading(true);
        setFetched(false);
        const q = query(collection(db, "client"));
        const querySnapshot = await getDocs(q);
        var data = [];
        var elements = {};
        querySnapshot.forEach((doc) => {
            elements = {
                id: doc.id,
                name: doc.data().name,
                clientId: doc.data().clientId,
                contact: doc.data().contact,
                address: doc.data().address,
            }
            data.push(elements);
            setRow(data);
        });
        setLoading(false);
        setFetched(true);
    }
    function finalDeletion(id) {
        const finalDelete = async (e) => {
            try {
                const documentRef = e;
                const contactRef = doc(db, "client", documentRef);
                await deleteDoc(contactRef);
                // deletion pachi cleanup
                // row update garne cleanup ko lagi

                setDeleted(true);

            } catch (e) {
                console.log(e)
            }
            setTimeout(() => {
                setDeleted(false);
            }, 3000);
        }
        finalDelete(id);
        setRow([]);
        getData();
        handleClse();



    }





    useEffect(() => {
        getData();
    }, [])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 200,
        height: 110,


        p: 2,
    };

    const columns = [
        { field: 'name', headerName: 'Name', width: 299, align: 'left', editable: true, cellClassName: `${openDelete && 'animate-pulse'}`, headerClassName: 'dark:text-white-rgba-6' },
        { field: 'clientId', headerName: 'Bill Number', type: 'string', width: 200, align: 'left', headerAlign: 'left', editable: true, cellClassName: `${openDelete && 'animate-pulse'}`, sortable: false, headerClassName: 'dark:text-white-rgba-6' },
        { field: 'contact', headerName: 'Contact', type: 'string', width: 200, align: 'left', headerAlign: 'left', editable: true, cellClassName: `${openDelete && 'animate-pulse'}`, sortable: false, headerClassName: 'dark:text-white-rgba-6' },
        { field: 'address', headerName: 'Address', type: 'string', width: 200, align: 'left', headerAlign: 'left', editable: true, cellClassName: `${openDelete && 'animate-pulse'}`, sortable: false, headerClassName: 'dark:text-white-rgba-6' },
        {
            field: 'actions', headerName: 'Actions', width: 200, align: 'left', headerAlign: 'left', align: 'left', sortable: false, headerClassName: 'dark:text-white-rgba-6',
            renderCell: (cellValues) => {
                return (
                    <>
                        <div className="px-3 py-1 mr-1 text-white rounded cursor-pointer bg-slate-700 hover:bg-slate-900"><Link to={`/admin/measurement/${cellValues.row.id}`}>Add</Link></div>
                        <div className="px-3 py-1 m-1 text-white rounded cursor-pointer bg-slate-700 hover:bg-slate-900 "><Link to={`/admin/measurement/view/${cellValues.row.id}`}>View</Link></div>
                        <div>
                            <div className="px-3 py-1 m-1 text-white bg-red-700 rounded cursor-pointer hover:bg-red-900" onClick={handleOpn}>Delete</div>

                            <Modal

                                open={opn}
                                onClose={handleClse}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={style} className='rounded cont'>
                                    <Typography id="modal-modal-title" className='mb-3 text-sm italic text-black dark:text-white-rgba-6 text-opacity-80'>
                                        Confirm Delete
                                    </Typography>
                                    <div className="flex"><div className="w-2/4 px-2 py-1 m-1 text-center text-white bg-red-700 rounded cursor-pointer hover:bg-red-900 " onClick={() => finalDeletion(cellValues.row.id)}>Delete</div>
                                        <div className="w-2/4 px-2 py-1 m-1 text-center text-white rounded cursor-pointer bg-slate-700 hover:bg-slate-900" onClick={handleClse}>Close</div></div>
                                </Box>
                            </Modal>
                        </div>
                    </>
                );
            }
        },

    ]
    return (
        <>

            <Sidebar>
                <div className="text-xl text-black bold">Clients</div>
                <p className='mb-3 text-sm italic text-black dark:text-white-rgba-6 text-opacity-40'>
                    Double click on a contact to edit it.
                </p>
                <div

                    onClick={() => setOpen(true)}
                    className='px-2 py-1 text-sm text-white rounded-sm cursor-pointer bg-slate-700 hover:bg-slate-900 mt-30 w-fit '
                >

                    NEW CLIENT
                </div>
                {open === true ? <Addnew /> : <>
                    {deleted && <Alert variant='outlined' className='my-3 text-sm text-green-500'>Client deleted successfully</Alert>}
                    <div className='max-h-[80%] h-full items-left'>
                        <DataGrid
                            autoHeight

                            headerHeight={20}
                            initialState={{
                                sorting: {
                                    sortModel: [{ field: 'id', sort: 'desc' }],
                                },
                            }}

                            rowsPerPageOptions={[20, 50, 100]}
                            rowHeight={35}
                            rows={row}
                            columns={columns}


                            disableSelectionOnClick={true}
                            className={`mb-2 ${openDelete && 'border-red-500 border-1'}`}
                            loading={loading}
                            disableColumnFilter
                            disableColumnSelector
                            disableDensitySelector
                            components={{
                                Toolbar: GridToolbar,
                                NoRowsOverlay: () => (
                                    <Stack className='text-center' height="100%" alignItems="center" justifyContent="center">

                                        <p className='mt-10 text-sm text-gray-600'>No contacts found. Refresh or add new contact.</p>
                                    </Stack>
                                ),

                            }}
                            componentsProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: { debounceMs: 500 },
                                }
                            }}
                            onCellEditCommit={(e) => {
                                editContact(e);
                            }}

                            getRowClassName={(e) =>
                                e.indexRelativeToCurrentPage % 2 === 0 ? 'bg-black bg-opacity-[0.025] dark:bg-grayer dark:text-white-rgba-9' : 'bg-white bg-opacity-[0.02]  dark:bg-white dark:bg-opacity-5 dark:text-white-rgba-9'
                            }
                            sx={{
                                boxShadow: 0,
                                border: 0,
                                padding: 0,
                                margin: 0,
                                textDecorationColor: 'black',
                                color: 'black',
                                menuDecorationColor: "black",



                            }}


                        />
                    </div>
                </>}
            </Sidebar>

        </>
    )
}

export default Client